import { StyleSheet } from 'react-native';

const style = StyleSheet.create({
  subTitle: {
    fontSize: 17,
    textAlign: 'center',
    lineHeight: 22,
    marginHorizontal: 5,
  },
  secondSubTitle: {
    marginTop: 30,
  },
  lottiStyle: {
    width: 125,
    height: 125,
    marginBottom: 40,
  },
});
export default style;
